<i18n lang="json">
  {
    "ru": {
      "Заполните анкету": "Заполните анкету и станьте частью команды",
      "Я ознакомлен": "Я ознакомлен (-а) и согласен (-на) с",
      "политикой": "политикой обработки персональных данных",
      "Отправить": "Отправить",
      "Спасибо!": "Спасибо!",
      "Мы рассмотрим": "Мы рассмотрим Вашу анкету и сообщим",
      "о решении в ближайшее время": "о решении в ближайшее время",
      "Фамилия, имя и отчество": "Фамилия, имя и отчество",
      "Электронная почта": "Электронная почта",
      "Должность, на которую Вы претендуете": "Должность, на которую Вы претендуете",
      "Прикрепите Ваше резюме": "Прикрепите Ваше резюме"
    },
    "en": {
      "Заполните анкету": "Fill out the form and become part of the team",
      "Я ознакомлен": "I have read and agree with the",
      "политикой": "personal data processing policy",
      "Отправить": "Submit",
      "Спасибо!": "Thank you!",
      "Мы рассмотрим": "We will review your application and inform you",
      "о решении в ближайшее время": "of the decision shortly",
      "Фамилия, имя и отчество": "Full name",
      "Электронная почта": "Email",
      "Должность, на которую Вы претендуете": "Position you are applying for",
      "Прикрепите Ваше резюме": "Attach your resume"
    },
    "tr": {
      "Заполните анкету": "Formu doldurun ve ekibimizin bir parçası olun",
      "Я ознакомлен": "Veri işleme politikasını okudum ve kabul ediyorum",
      "политикой": "kişisel veri işleme politikası",
      "Отправить": "Gönder",
      "Спасибо!": "Teşekkürler!",
      "Мы рассмотрим": "Başvurunuzu inceleyeceğiz ve sizi bilgilendireceğiz",
      "о решении в ближайшее время": "kararı en kısa sürede bildireceğiz",
      "Фамилия, имя и отчество": "Ad, soyad",
      "Электронная почта": "E-posta",
      "Должность, на которую Вы претендуете": "Başvurduğunuz pozisyon",
      "Прикрепите Ваше резюме": "Özgeçmişinizi ekleyin"
    },
    "es": {
      "Заполните анкету": "Complete el formulario y sea parte del equipo",
      "Я ознакомлен": "He leído y estoy de acuerdo con la",
      "политикой": "política de procesamiento de datos personales",
      "Отправить": "Enviar",
      "Спасибо!": "¡Gracias!",
      "Мы рассмотрим": "Revisaremos su solicitud y le informaremos",
      "о решении в ближайшее время": "sobre la decisión en breve",
      "Фамилия, имя и отчество": "Nombre completo",
      "Электронная почта": "Correo electrónico",
      "Должность, на которую Вы претендуете": "Posición a la que postula",
      "Прикрепите Ваше резюме": "Adjunte su currículum"
    },
    "ar": {
      "Заполните анкету": "املأ النموذج وانضم إلى الفريق",
      "Я ознакомлен": "لقد قرأت ووافقت على",
      "политикой": "سياسة معالجة البيانات الشخصية",
      "Отправить": "إرسال",
      "Спасибо!": "شكراً!",
      "Мы рассмотрим": "سوف نراجع طلبك ونعلمك",
      "о решении в ближайшее время": "بالقرار في أقرب وقت",
      "Фамилия, имя и отчество": "الاسم الكامل",
      "Электронная почта": "البريد الإلكتروني",
      "Должность, на которую Вы претендуете": "الوظيفة التي تتقدم لها",
      "Прикрепите Ваше резюме": "أرفق سيرتك الذاتية"
    }
  }
</i18n>
<script setup>
import toStrapiLocale from "../helpers/toStrapiLocale";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  email as emailValidator,
} from "@vuelidate/validators";
const { t } = useI18n({ useScope: "local" });
const name = ref("");
const phone = ref("");
const position = ref("");
const email = ref("");
const file = ref(null);
const isAgree = ref(false);

const route = useRoute();
const { $get, $post } = useAxios();
const { locale } = useI18n();
const vacancyId = computed(() => route.query.id);

const vacancy = ref(null)

watch(vacancyId, async()=> {
  let res = await $get(`/vacancies/${vacancyId.value}?_locale=${toStrapiLocale(locale.value)}`)
  position.value = res.title
})

function isTrue(value) {
  return !!value;
}

const rules = reactive({
  name: {
    required,
    minLength: minLength(1),
  },
  phone: {
    required,
    minLength: minLength(18),
    maxLength: maxLength(18),
  },
  email: {
    required,
    emailValidator,
    minLength: minLength(3),
  },
  position: {
    required,
  },
  file: {
    required,
  },
  isAgree: {
    required,
    isTrue,
  },
});

watch(phone, (newValue) => {
  if (newValue && !newValue.startsWith("+7")) {
    phone.value = "+7" + newValue;
  }
  if (newValue.length > 18) {
    phone.value = newValue.slice(0, 18);
  }
});

const validator = useVuelidate(
  rules,
  { name, phone, email, position, file, isAgree },
  { $rewardEarly: true }
);

const isSubmit = ref(false);

function resetForm() {
  isSubmited.value = false;
  name.value = "";
  phone.value = "";
  email.value = "";
  position.value = "";
  file.value = null;
  isAgree.value = false;
  validator.value.$reset();
}

const isSubmited = ref(false);

async function onSubmit() {
  isSubmit.value = true;
  try {
    const isValid = await validator.value.$validate();
    if (!isValid || !isAgree.value) {
      alert("Проверьте правильность введенных данных");
      isSubmit.value = false;
      return;
    }

    await $post("/vacancies-emails", {
      name: name.value,
      phone: phone.value,
      email: email.value,
      position: position.value,
      resume_link: file.value?.uploadURL,
    });

    isSubmit.value = false;
    isSubmited.value = true;
  } catch (err) {
    isSubmit.value = false;
    alert("Возникла ошибка. Попробуйте позже");
    console.error(err);
  }
}
</script>

<template>
  <div class="container px-4 xl:px-0" id="vacancyForm">
    {{ vacancy }}
    <div
      class="font-firasans pb-4 lg:pb-8 font-medium text-base sm:text-[26px]"
    >
      {{t('Заполните анкету')}}
    </div>
    <div
      class="relative justify-center flex flex-col space-y-2 lg:space-y-0 lg:block rounded-[20px] lg:p-5 lg:shadow"
    >
      <div class="block w-full h-56 xs:h-68 lg:hidden">
        <a-icon-vacancy-mobile class="mx-auto w-80 xs:w-95 h-56 xs:h-68">
        </a-icon-vacancy-mobile>
      </div>
      <div class="grid grid-cols-2 w-full lg:w-127 gap-5" v-if="!isSubmited">
        <AInput
          v-model.trim="name"
          :isValid="!validator.name.$error"
          @blur="validator.name.$commit"
          name="name"
          class="col-span-2 rounded-xl md:rounded-3xl"
          styleInput="simple"
          height="large"
          :placeholder="t('Фамилия, имя и отчество')"
        ></AInput>

        <AInput
          v-model.trim="phone"
          :isValid="!validator.phone.$error"
          @blur="validator.phone.$commit"
          v-mask="'+# (###) ###-##-##'"
          name="phone"
          class="col-span-2 md:col-span-1 rounded-xl md:rounded-3xl"
          styleInput="simple"
          height="large"
          placeholder="+7 ("
        ></AInput>
        <AInput
          v-model.trim="email"
          :isValid="!validator.email.$error"
          @blur="validator.email.$commit"
          name="email"
          class="col-span-2 md:col-span-1 rounded-xl md:rounded-3xl"
          styleInput="simple"
          height="large"
          :placeholder="t('Электронная почта')"
        ></AInput>
        <AInput
          v-model.trim="position"
          :isValid="!validator.position.$error"
          @blur="validator.position.$commit"
          name="position"
          class="col-span-2 rounded-xl md:rounded-3xl"
          styleInput="simple"
          height="large"
          :placeholder="t('Должность, на которую Вы претендуете')"
        ></AInput>

        <vue-uppy
          class="col-span-2"
          v-model="file"
          :placeholder="t('Прикрепите Ваше резюме')"
          :is-valid="!validator.file.$error"
        />
        <div class="flex col-span-2 items-center flex-row space-x-1">
          <AinputCheckbox
            id="agreeid"
            v-model="isAgree"
            :isValid="!validator.isAgree.$error"
            label=""
          >
          </AinputCheckbox>
          <div class="text-sm sm:text-base pb-0.5 font-sans text-[#6F6F6F]">
            {{t('Я ознакомлен')}}
            <a
              href="/"
              class="underline text-[#004BA3] lg:text-[#6F6F6F] font-medium"
              >{{t('политикой')}}
            </a>
          </div>
        </div>

        <div class="w-50 hidden md:block">
          <AButton
            @click="onSubmit()"
            width="medium"
            :loading="isSubmit"
            :disabled="isSubmit"
            class="col-span-2 mt-[10px] text-[#333333] w-50 font-medium block"
            >{{t('Отправить')}}</AButton
          >
        </div>
        <div class="w-full md:hidden col-span-2">
          <AButton
            @click="onSubmit()"
            width="mobile"
            :loading="isSubmit"
            :disabled="isSubmit"
            class="mt-[10px] w-full text-[#333333] font-medium block"
            >{{t('Отправить')}}</AButton
          >
        </div>
      </div>
      <div
        v-if="isSubmited"
        class="md:h-[430px] w-full items-center h-full flex flex-col lg:block relative lg:py-8 px-0 xl:px-4"
      >
        <div class="lg:pt-24">
          <p
            class="text-xl md:text-4xl mb-3 md:mb-5 font-firasans md:font-semibold"
          >
            {{t('Спасибо!')}}
          </p>
          <p class="text-sm md:text-lg !leading-7 text-[#333333] font-sans">
            {{t('Мы рассмотрим')}}<br />
            {{t('о решении в ближайшее время')}}.
          </p>
        </div>
      </div>

      <div class="absolute hidden lg:block bottom-0 right-8 xl:right-20">
        <a-icon-vacancy class="w-95 h-95 xl:w-110 xl:h-105"> </a-icon-vacancy>
      </div>
    </div>
  </div>
</template>

<style scoped>
.shadow {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 4px 0px;
}
</style>
